// Maťa:
// Dočasné pomocné funkce pro pro vyhodnocení práv na prvcích
// Použito jen zpětnou kompatibilitu
// Až se vyhodnocování práv předelá tak tento soubor smazat
import { IClassItemRights as RemotingClassItemRights } from "../../../OW.Remoting/Remoting/Rights";

export interface IClassItemRights extends RemotingClassItemRights {
    /**
     * Hodnota práva zda se ma zavrit formular po vykonani akce
     */
    closeForm?: boolean;

    validate?: boolean;
    confirm?: boolean;
    /**
     * Výsledek vyhodnocení práv zda má být povoleno vytváření podpisů
     */
    useDigitalSign?: boolean;

    /**
     * Výsledek vyhodnocení práv zda má být povoleno šifrování
     */
    useEncryption?: boolean;

    /**
     * Výsledek vyhodnocení práv zda má být povoleno dešifrování
     */
    useDecryption?: boolean;
}
